import {
  handlePowerToFlowConversion,
  HandlePowerToFlowConversionArgs,
} from "./handlePowerToFlowConversion";
import { initLoadingState, InitLoadingStateArgs } from "./initLoadingState";
import { remapPipeSize } from "./remapPipeSize";

type ProcessRowUpdateArgs = HandlePowerToFlowConversionArgs &
  InitLoadingStateArgs;

export function processRowUpdate({
  correlationId,
  prevRow,
  row,
  ...args
}: ProcessRowUpdateArgs) {
  const withPipeSize = remapPipeSize(row, prevRow);
  const withFlow = handlePowerToFlowConversion({
    prevRow,
    row: withPipeSize,
    ...args,
  });
  return initLoadingState({
    correlationId,
    prevRow,
    row: withFlow,
  });
}
